function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMusicBro({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M248.27,73s-65.36,3.31-107.56,58.66-43.36,131-45.93,192.23,33.34,107.61,85.94,113.72,66.79-40.91,125.81-67.38,78.7-24.57,114-78.92,10.61-137.89-53.4-180.74S248.27,73,248.27,73Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.27,73s-65.36,3.31-107.56,58.66-43.36,131-45.93,192.23,33.34,107.61,85.94,113.72,66.79-40.91,125.81-67.38,78.7-24.57,114-78.92,10.61-137.89-53.4-180.74S248.27,73,248.27,73Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Icons--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M145.38,296.3a5.24,5.24,0,0,1-5.23-5.24V232.8a4.53,4.53,0,0,0-9.06,0v43.5a4.65,4.65,0,0,1-9.29,0v-24a3.35,3.35,0,1,0-6.69,0v8.93h-7.38v-1h6.38v-7.93a4.35,4.35,0,1,1,8.69,0v24a3.65,3.65,0,0,0,7.29,0V232.8a5.53,5.53,0,0,1,11.06,0v58.26a4.24,4.24,0,1,0,8.47,0V220a6.72,6.72,0,1,1,13.43,0v70.75a4.53,4.53,0,0,0,9.06,0V234.36a6.42,6.42,0,1,1,12.84,0V276a3.94,3.94,0,0,0,7.88,0V253.34a4.74,4.74,0,0,1,9.47,0v6.87h7.37v1H201.3v-7.87a3.74,3.74,0,0,0-7.47,0V276a4.94,4.94,0,0,1-9.88,0V234.36a5.42,5.42,0,1,0-10.84,0v56.38a5.53,5.53,0,0,1-11.06,0V220a5.72,5.72,0,1,0-11.43,0v71.07A5.25,5.25,0,0,1,145.38,296.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.88,296.3a5.24,5.24,0,0,1-5.23-5.24V232.8a4.53,4.53,0,0,0-9.06,0v43.5a4.65,4.65,0,0,1-9.29,0v-24a3.35,3.35,0,1,0-6.69,0v8.93h-7.38v-1h6.38v-7.93a4.35,4.35,0,1,1,8.69,0v24a3.65,3.65,0,0,0,7.29,0V232.8a5.53,5.53,0,0,1,11.06,0v58.26a4.24,4.24,0,1,0,8.47,0V220a6.72,6.72,0,1,1,13.43,0v70.75a4.53,4.53,0,1,0,9.06,0V234.36a6.42,6.42,0,0,1,12.84,0V276a3.94,3.94,0,0,0,7.88,0V253.34a4.73,4.73,0,0,1,9.46,0v6.87h7.38v1h-8.38v-7.87a3.73,3.73,0,0,0-7.46,0V276a4.94,4.94,0,0,1-9.88,0V234.36a5.42,5.42,0,0,0-10.84,0v56.38a5.53,5.53,0,0,1-11.06,0V220a5.72,5.72,0,1,0-11.43,0v71.07A5.25,5.25,0,0,1,241.88,296.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.38,296.3a5.24,5.24,0,0,1-5.23-5.24V232.8a4.53,4.53,0,1,0-9.06,0v43.5a4.65,4.65,0,0,1-9.29,0v-24a3.35,3.35,0,1,0-6.69,0v8.93h-7.39v-1h6.39v-7.93a4.35,4.35,0,1,1,8.69,0v24a3.65,3.65,0,0,0,7.29,0V232.8a5.53,5.53,0,1,1,11.06,0v58.26a4.24,4.24,0,1,0,8.47,0V220a6.72,6.72,0,1,1,13.43,0v70.75a4.53,4.53,0,1,0,9.06,0V234.36a6.42,6.42,0,0,1,12.84,0V276a3.94,3.94,0,0,0,7.88,0V253.34a4.73,4.73,0,0,1,9.46,0v6.87h7.38v1h-8.38v-7.87a3.73,3.73,0,0,0-7.46,0V276a4.94,4.94,0,0,1-9.88,0V234.36a5.42,5.42,0,0,0-10.84,0v56.38a5.53,5.53,0,1,1-11.06,0V220a5.72,5.72,0,1,0-11.43,0v71.07A5.25,5.25,0,0,1,338.38,296.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "252.21 106.59 252.21 97.32 244.19 101.95 252.21 106.59",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 241.52,
    y: 97.1,
    width: 1.46,
    height: 9.47,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "294.67 106.59 302.7 101.95 294.67 97.32 294.67 106.59",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 303.91,
    y: 97.1,
    width: 1.46,
    height: 9.47,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.91,88.49a12.34,12.34,0,1,0,12.34,12.34A12.34,12.34,0,0,0,273.91,88.49Zm-1.75,18.84h-3.67v-13h3.67Zm7.17,0h-3.67v-13h3.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316.94,
    y: 404.75,
    width: 11.63,
    height: 4.23,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316.94,
    y: 398.76,
    width: 11.63,
    height: 4.23,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316.94,
    y: 392.77,
    width: 11.63,
    height: 4.23,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316.94,
    y: 386.78,
    width: 11.63,
    height: 4.23,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 347.06,
    y: 404.75,
    width: 11.63,
    height: 4.23,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 347.06,
    y: 398.76,
    width: 11.63,
    height: 4.23,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 286.81,
    y: 404.75,
    width: 11.63,
    height: 4.23,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 286.81,
    y: 398.76,
    width: 11.63,
    height: 4.23,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 301.87,
    y: 404.75,
    width: 11.63,
    height: 4.23,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 301.87,
    y: 398.76,
    width: 11.63,
    height: 4.23,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 301.87,
    y: 392.77,
    width: 11.63,
    height: 4.23,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 301.87,
    y: 386.78,
    width: 11.63,
    height: 4.23,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 301.87,
    y: 380.79,
    width: 11.63,
    height: 4.23,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 301.87,
    y: 374.8,
    width: 11.63,
    height: 4.23,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 301.87,
    y: 368.81,
    width: 11.63,
    height: 4.23,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 332,
    y: 404.75,
    width: 11.63,
    height: 4.23,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 332,
    y: 398.76,
    width: 11.63,
    height: 4.23,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 332,
    y: 392.77,
    width: 11.63,
    height: 4.23,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 332,
    y: 386.78,
    width: 11.63,
    height: 4.23,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 332,
    y: 380.79,
    width: 11.63,
    height: 4.23,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 332,
    y: 374.8,
    width: 11.63,
    height: 4.23,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.29,182.3a1.5,1.5,0,0,1-1.5-1.5V167.25a1.5,1.5,0,0,1,3,0V180.8A1.5,1.5,0,0,1,85.29,182.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.38,180.51a1.5,1.5,0,0,1-1.5-1.5V169a1.5,1.5,0,0,1,3,0v10A1.5,1.5,0,0,1,80.38,180.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.47,180.51A1.5,1.5,0,0,1,74,179V169a1.5,1.5,0,0,1,3,0v10A1.5,1.5,0,0,1,75.47,180.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.37,180.51a1.5,1.5,0,0,1-1.5-1.5V169a1.5,1.5,0,1,1,3,0v10A1.5,1.5,0,0,1,134.37,180.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.47,180.51A1.5,1.5,0,0,1,128,179V169a1.5,1.5,0,0,1,3,0v10A1.5,1.5,0,0,1,129.47,180.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.2,182.3a1.5,1.5,0,0,1-1.5-1.5V167.25a1.5,1.5,0,0,1,3,0V180.8A1.5,1.5,0,0,1,90.2,182.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.11,184.68a1.5,1.5,0,0,1-1.5-1.5V164.86a1.5,1.5,0,0,1,3,0v18.32A1.5,1.5,0,0,1,95.11,184.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100,188.44a1.51,1.51,0,0,1-1.5-1.5V161.11a1.5,1.5,0,0,1,3,0v25.83A1.5,1.5,0,0,1,100,188.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.56,182.3a1.5,1.5,0,0,1-1.5-1.5V167.25a1.5,1.5,0,0,1,3,0V180.8A1.5,1.5,0,0,1,124.56,182.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.65,182.3a1.5,1.5,0,0,1-1.5-1.5V167.25a1.5,1.5,0,0,1,3,0V180.8A1.5,1.5,0,0,1,119.65,182.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.74,184.68a1.5,1.5,0,0,1-1.5-1.5V164.86a1.5,1.5,0,0,1,3,0v18.32A1.5,1.5,0,0,1,114.74,184.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.83,188.44a1.5,1.5,0,0,1-1.5-1.5V161.11a1.5,1.5,0,0,1,3,0v25.83A1.5,1.5,0,0,1,109.83,188.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.92,193.21a1.5,1.5,0,0,1-1.5-1.5V156.33a1.5,1.5,0,0,1,3,0v35.38A1.5,1.5,0,0,1,104.92,193.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.78,169.28a12.07,12.07,0,0,0-23.53.14,12.07,12.07,0,0,0,.71,24l.22-2.42a9.64,9.64,0,0,1,.19-19.21l1-.07.14-1a9.63,9.63,0,0,1,19.08,0l.16,1.18,1.19-.13a9.48,9.48,0,0,1,1.08-.07A9.65,9.65,0,0,1,405,191v2.44a12.08,12.08,0,1,0-.22-24.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.79,179.05a1.21,1.21,0,0,0-.49-1,1.23,1.23,0,0,0-1.08-.19l-12.81,3.8a1.21,1.21,0,0,0-.87,1.17v14.66a3.83,3.83,0,0,0-1.36-.26,3.78,3.78,0,1,0,3.74,4.1H388V190.16l10.38-3.07v6.48a3.66,3.66,0,0,0-1.33-.26,3.77,3.77,0,1,0,3.77,3.77v-18Zm-2.44,5.49L388,187.62v-3.86l10.38-3.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.09,351.83a16,16,0,1,0,16,16A16,16,0,0,0,140.09,351.83Zm0,21.83a5.8,5.8,0,1,1,5.8-5.8A5.8,5.8,0,0,1,140.09,373.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.09,326.59a9.89,9.89,0,1,0,9.89,9.89A9.88,9.88,0,0,0,140.09,326.59Zm0,13.46a3.58,3.58,0,1,1,3.57-3.57A3.57,3.57,0,0,1,140.09,340.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.74,389.05h-33.3a4.45,4.45,0,0,1-4.45-4.44V325.46a4.45,4.45,0,0,1,4.45-4.44h33.3a4.44,4.44,0,0,1,4.44,4.44v59.15A4.44,4.44,0,0,1,156.74,389.05Zm-33.3-67a3.45,3.45,0,0,0-3.45,3.44v59.15a3.45,3.45,0,0,0,3.45,3.44h33.3a3.45,3.45,0,0,0,3.44-3.44V325.46a3.45,3.45,0,0,0-3.44-3.44Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M228.33,151.66c0-1.39,1.9-2.89,1.72-4.23s-2.4-2.34-2.75-3.65,1.09-3.27.57-4.53-2.93-1.62-3.61-2.8.2-3.44-.63-4.53-3.24-.8-4.21-1.77-.69-3.38-1.78-4.21-3.33.06-4.52-.63-1.53-3.08-2.8-3.61-3.2.93-4.53.57-2.27-2.58-3.65-2.76-2.84,1.73-4.23,1.73-2.89-1.9-4.23-1.73-2.33,2.41-3.64,2.76-3.28-1.09-4.54-.57-1.62,2.93-2.8,3.61-3.44-.21-4.52.63-.81,3.24-1.78,4.21-3.37.68-4.21,1.77.06,3.34-.62,4.53-3.09,1.53-3.61,2.8.92,3.2.56,4.53-2.57,2.27-2.75,3.64,1.73,2.85,1.73,4.24-1.91,2.88-1.73,4.23,2.4,2.33,2.75,3.64-1.09,3.28-.56,4.53,2.92,1.62,3.61,2.81-.21,3.44.62,4.52,3.25.8,4.21,1.77.69,3.38,1.78,4.21,3.33-.06,4.52.63,1.53,3.08,2.8,3.61,3.2-.92,4.54-.57,2.27,2.58,3.64,2.76,2.84-1.73,4.23-1.73,2.89,1.9,4.23,1.73,2.33-2.41,3.65-2.76,3.27,1.09,4.53.57,1.62-2.93,2.8-3.61,3.44.21,4.53-.63.8-3.24,1.77-4.21,3.37-.68,4.21-1.77-.06-3.34.63-4.53,3.08-1.52,3.61-2.8-.93-3.19-.57-4.53,2.57-2.27,2.75-3.64S228.33,153.05,228.33,151.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.86,184.31l-.24,0a4,4,0,0,1-2.24-1.56,4,4,0,0,0-1.47-1.21,4.17,4.17,0,0,0-1.92.31,3.94,3.94,0,0,1-2.68.24,4.07,4.07,0,0,1-1.74-2.08,2.34,2.34,0,0,0-3-1.75,4,4,0,0,1-2.66-.47,4.08,4.08,0,0,1-1.14-2.45,2.35,2.35,0,0,0-2.48-2.49,4,4,0,0,1-2.45-1.13,4,4,0,0,1-.47-2.66,3.92,3.92,0,0,0-.2-1.92,3.86,3.86,0,0,0-1.55-1.12,2.91,2.91,0,0,1-1.85-4.42,2.34,2.34,0,0,0-.89-3.39,4.13,4.13,0,0,1-1.57-2.24,4.05,4.05,0,0,1,.93-2.51,2.39,2.39,0,0,0,0-3.57,4,4,0,0,1-.93-2.51,4.07,4.07,0,0,1,1.57-2.23,4,4,0,0,0,1.2-1.48,3.87,3.87,0,0,0-.31-1.91,2.92,2.92,0,0,1,1.85-4.43,2.34,2.34,0,0,0,1.75-3,2.92,2.92,0,0,1,2.92-3.8,4,4,0,0,0,1.8-.68,4,4,0,0,0,.68-1.8,2.91,2.91,0,0,1,3.8-2.92,4.17,4.17,0,0,0,1.92-.2,4,4,0,0,0,1.12-1.56,2.92,2.92,0,0,1,4.42-1.84,2.34,2.34,0,0,0,3.39-.9,4.07,4.07,0,0,1,2.24-1.56,4,4,0,0,1,2.51.92,4.06,4.06,0,0,0,1.78.8,4,4,0,0,0,1.78-.8,2.92,2.92,0,0,1,4.75.64,4,4,0,0,0,1.48,1.21,4.15,4.15,0,0,0,1.91-.31,2.92,2.92,0,0,1,4.42,1.84,2.34,2.34,0,0,0,3,1.75,4.13,4.13,0,0,1,2.66.47,4.08,4.08,0,0,1,1.14,2.46,4,4,0,0,0,.68,1.79,4,4,0,0,0,1.8.69,2.92,2.92,0,0,1,2.92,3.8,2.34,2.34,0,0,0,1.75,3,2.92,2.92,0,0,1,1.85,4.43,4,4,0,0,0-.31,1.91,4.1,4.1,0,0,0,1.2,1.48,2.91,2.91,0,0,1,.65,4.74,2.39,2.39,0,0,0,0,3.57,4,4,0,0,1,.92,2.51,4.13,4.13,0,0,1-1.57,2.24,4,4,0,0,0-1.2,1.47,4,4,0,0,0,.31,1.92,2.91,2.91,0,0,1-1.85,4.42,3.86,3.86,0,0,0-1.55,1.12,3.92,3.92,0,0,0-.2,1.92,2.91,2.91,0,0,1-2.92,3.79,2.35,2.35,0,0,0-2.48,2.48,2.92,2.92,0,0,1-3.8,2.93,2.34,2.34,0,0,0-3,1.75,2.92,2.92,0,0,1-4.42,1.84,4.11,4.11,0,0,0-1.91-.31,4,4,0,0,0-1.48,1.21,2.92,2.92,0,0,1-4.75.64,4,4,0,0,0-1.78-.8,4.06,4.06,0,0,0-1.78.8A4.57,4.57,0,0,1,193.86,184.31Zm-4.29-3.83a2.47,2.47,0,0,1,.6.08,4.59,4.59,0,0,1,2,1.49c.53.58,1.08,1.18,1.62,1.25a3.52,3.52,0,0,0,1.85-.77,3.28,3.28,0,0,1,4.64,0,3.52,3.52,0,0,0,1.85.77c.54-.07,1.09-.67,1.63-1.25a4.47,4.47,0,0,1,1.95-1.49,4.58,4.58,0,0,1,2.47.32,3.49,3.49,0,0,0,2,.27c.5-.21.87-.93,1.24-1.62a3.24,3.24,0,0,1,4-2.29,3.51,3.51,0,0,0,2-.26,3.44,3.44,0,0,0,.77-1.88,4.6,4.6,0,0,1,.95-2.29,4.55,4.55,0,0,1,2.29-.95,2,2,0,0,0,2.14-2.78,4.69,4.69,0,0,1,.33-2.47,4.62,4.62,0,0,1,2-1.5c.7-.36,1.42-.74,1.62-1.24a3.34,3.34,0,0,0-.27-2,4.68,4.68,0,0,1-.32-2.47,4.62,4.62,0,0,1,1.5-2c.58-.53,1.18-1.09,1.25-1.63a3.46,3.46,0,0,0-.78-1.84,4.66,4.66,0,0,1-.95-2.32,4.59,4.59,0,0,1,.95-2.32,3.49,3.49,0,0,0,.78-1.85c-.07-.54-.67-1.09-1.25-1.63a4.56,4.56,0,0,1-1.5-2,4.68,4.68,0,0,1,.32-2.47,3.33,3.33,0,0,0,.27-2c-.2-.5-.92-.88-1.62-1.24a4.54,4.54,0,0,1-2-1.5,4.67,4.67,0,0,1-.33-2.46,2,2,0,0,0-2.14-2.79,4.55,4.55,0,0,1-2.29-.95,4.6,4.6,0,0,1-.95-2.29,3.44,3.44,0,0,0-.77-1.88,3.51,3.51,0,0,0-2-.26,4.45,4.45,0,0,1-2.46-.33,4.57,4.57,0,0,1-1.5-1.95c-.37-.7-.74-1.42-1.24-1.63a3.49,3.49,0,0,0-2,.27,4.58,4.58,0,0,1-2.47.32,4.47,4.47,0,0,1-1.95-1.49c-.54-.58-1.09-1.18-1.63-1.25a3.38,3.38,0,0,0-1.85.78,3.31,3.31,0,0,1-4.64,0,3.46,3.46,0,0,0-1.85-.78c-.54.07-1.09.67-1.62,1.25a3.25,3.25,0,0,1-4.43,1.17,3.49,3.49,0,0,0-2-.27c-.5.21-.87.93-1.24,1.63a4.51,4.51,0,0,1-1.5,1.95,4.45,4.45,0,0,1-2.46.33,2,2,0,0,0-2.78,2.15,4.61,4.61,0,0,1-1,2.28,4.55,4.55,0,0,1-2.29.95,3.52,3.52,0,0,0-1.88.78,3.43,3.43,0,0,0-.26,2,4.67,4.67,0,0,1-.33,2.46,4.54,4.54,0,0,1-2,1.5c-.7.36-1.42.74-1.62,1.24a3.41,3.41,0,0,0,.27,2,3.25,3.25,0,0,1-1.17,4.42c-.58.54-1.18,1.09-1.25,1.63a3.47,3.47,0,0,0,.77,1.85,4.6,4.6,0,0,1,1,2.32,4.68,4.68,0,0,1-1,2.32,3.41,3.41,0,0,0-.77,1.84c.07.54.67,1.1,1.25,1.63a4.67,4.67,0,0,1,1.49,2,4.58,4.58,0,0,1-.32,2.47,3.5,3.5,0,0,0-.27,2c.2.5.92.88,1.62,1.24a4.56,4.56,0,0,1,2,1.51,4.64,4.64,0,0,1,.33,2.46,2,2,0,0,0,2.14,2.78,4.55,4.55,0,0,1,2.29.95,4.6,4.6,0,0,1,1,2.29,2,2,0,0,0,2.78,2.14,3.26,3.26,0,0,1,4,2.29c.36.69.74,1.41,1.23,1.62a3.49,3.49,0,0,0,2-.27A6.46,6.46,0,0,1,189.57,180.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.19,161.42a1,1,0,0,1-.92-.59,22.38,22.38,0,0,1-1.59-5.3c-2-11.28,4.89-21.92,15.25-23.71s20.37,6,22.32,17.23c.11.66.2,1.31.25,2a1,1,0,1,1-2,.17c0-.59-.13-1.19-.23-1.79-1.76-10.2-10.73-17.19-20-15.6s-15.38,11.2-13.62,21.4A20.42,20.42,0,0,0,182.1,160a1,1,0,0,1-.51,1.32A1,1,0,0,1,181.19,161.42Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.19,161.92a1.51,1.51,0,0,1-1.38-.89,23.47,23.47,0,0,1-1.63-5.41,22.15,22.15,0,0,1,3.09-15.78,18.45,18.45,0,0,1,27.28-4.7A22.11,22.11,0,0,1,216.74,149c.12.66.2,1.34.26,2a1.5,1.5,0,0,1-1.37,1.62,1.48,1.48,0,0,1-1.62-1.37c0-.57-.12-1.16-.22-1.74-1.71-9.93-10.43-16.74-19.43-15.19s-14.93,10.89-13.22,20.82a20,20,0,0,0,1.42,4.71,1.5,1.5,0,0,1-.77,2A1.38,1.38,0,0,1,181.19,161.92Zm15.75-29.86a18,18,0,0,0-2.92.25,17.69,17.69,0,0,0-11.91,8.08,21.07,21.07,0,0,0-2.94,15.06,22.13,22.13,0,0,0,1.56,5.18.51.51,0,0,0,.66.25.5.5,0,0,0,.25-.66,21.37,21.37,0,0,1-1.49-4.94c-1.8-10.47,4.49-20.33,14-22s18.78,5.54,20.58,16c.11.61.19,1.23.24,1.83a.49.49,0,0,0,.54.45.51.51,0,0,0,.34-.17.48.48,0,0,0,.11-.37c-.05-.63-.13-1.27-.24-1.91a21.1,21.1,0,0,0-7.82-13.21A17.93,17.93,0,0,0,196.94,132.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.24,305.35s40.63-10,53.29-22c0,0-3.66,19,3,29s33.28,36.46,37.94,41.79,13.4,17.88,16.06,17.54,10-12.33,12.34-15.66,6.39-5.45,7.05-11.12-2.66-6-4-4.33-8.21,6.88-12.55,8.21-9,2.89-9,2.89a222.8,222.8,0,0,1-18.5-31c-8-16.67-16.32-48-19-54.32s-6.67-8.33-11.67-8.33-21,0-49,12.33-27,24.33-24.33,28.67S239.2,307.07,248.24,305.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.44,372.24c-2.08,0-6-4.74-11.64-11.91-1.74-2.21-3.39-4.3-4.7-5.81s-4.39-4.7-8.29-8.75c-9.91-10.31-24.89-25.89-29.69-33.09-5.72-8.58-4-23.32-3.32-28-13.62,11.51-50.82,20.72-52.44,21.12h0c-9.2,1.74-16.12-2-18.89-6.52a10.39,10.39,0,0,1-.76-8.64c1.58-5.07,7.26-12.79,25.32-20.75,28.1-12.37,44-12.37,49.2-12.37,5.79,0,9.65,2.74,12.13,8.64.89,2.12,2.41,7,4.33,13.18,3.93,12.67,9.32,30,14.64,41.11a225,225,0,0,0,18.24,30.63c1.17-.38,5.07-1.67,8.68-2.78,4.26-1.3,11.07-6.49,12.31-8a2.64,2.64,0,0,1,3.05-.88c.71.29,2.33,1.44,1.84,5.58s-2.67,6.42-4.78,8.62a22.73,22.73,0,0,0-2.36,2.72c-.45.64-1.07,1.58-1.81,2.7-4.47,6.79-8.67,12.9-10.87,13.18ZM301.53,282.9a.48.48,0,0,1,.24.06.51.51,0,0,1,.26.53c0,.19-3.56,18.92,2.92,28.63,4.75,7.13,19.69,22.67,29.58,33,3.9,4.06,7,7.26,8.32,8.79s3,3.62,4.74,5.84c3.68,4.67,9.28,11.73,10.88,11.53,1.93-.24,7.49-8.68,10.17-12.74.74-1.13,1.37-2.08,1.82-2.72a24.78,24.78,0,0,1,2.46-2.85c2-2.08,4.06-4.23,4.51-8,.28-2.41-.18-4.11-1.24-4.55a1.66,1.66,0,0,0-1.88.58c-1.32,1.66-8.29,7-12.79,8.38-4.28,1.32-9,2.87-9,2.89A.5.5,0,0,1,352,352a224.37,224.37,0,0,1-18.55-31.09c-5.36-11.16-10.76-28.55-14.7-41.24-1.91-6.15-3.42-11-4.29-13.1-2.34-5.55-5.8-8-11.21-8-5.17,0-20.89,0-48.8,12.29-17.71,7.8-23.24,15.25-24.76,20.13a9.4,9.4,0,0,0,.65,7.81c2.59,4.21,9.11,7.72,17.84,6.07.92-.23,40.72-10.14,53.06-21.83A.51.51,0,0,1,301.53,282.9Zm-53.29,22.46h0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.92,345c.67-5.66-2.66-6-4-4.33s-8.21,6.88-12.55,8.21-9,2.89-9,2.89a226.72,226.72,0,0,1-15.6-25.25,25.58,25.58,0,0,1-11.34,9.8c7.65,8.06,14.84,15.39,17.06,17.92,4.67,5.34,13.4,17.88,16.06,17.54s10-12.33,12.34-15.66S377.26,350.62,377.92,345Z",
    style: {
      fill: "#d9d9d9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.44,372.24c-2.08,0-6-4.74-11.64-11.91-1.74-2.21-3.39-4.3-4.7-5.81s-4.4-4.71-8.3-8.77c-2.65-2.74-5.66-5.88-8.75-9.13a.5.5,0,0,1,.16-.81,25.09,25.09,0,0,0,11.12-9.61.55.55,0,0,1,.45-.23.52.52,0,0,1,.42.27,229.26,229.26,0,0,0,15.34,24.89c1.17-.38,5.07-1.67,8.68-2.78,4.26-1.3,11.07-6.49,12.31-8a2.64,2.64,0,0,1,3.05-.88c.71.29,2.33,1.44,1.84,5.58h0c-.49,4.14-2.67,6.42-4.78,8.62a22.73,22.73,0,0,0-2.36,2.72c-.45.64-1.07,1.58-1.81,2.7-4.47,6.79-8.67,12.9-10.87,13.18Zm-32.18-35.8c2.92,3.07,5.75,6,8.26,8.62,3.91,4.07,7,7.28,8.33,8.81s3,3.62,4.74,5.84c3.68,4.67,9.28,11.73,10.88,11.53,1.93-.24,7.49-8.68,10.17-12.74.74-1.13,1.37-2.08,1.82-2.72a24.78,24.78,0,0,1,2.46-2.85c2-2.08,4.06-4.23,4.51-8,.28-2.41-.18-4.11-1.24-4.55a1.66,1.66,0,0,0-1.88.58c-1.32,1.66-8.29,7-12.79,8.38-4.28,1.32-9,2.87-9,2.89A.5.5,0,0,1,352,352a228.18,228.18,0,0,1-15.24-24.57A26.14,26.14,0,0,1,326.26,336.44ZM377.92,345h0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.22,177.93s4.39,9,4.88,12-2.93,4.64-6.35,5.37S187,194,181.6,200.14,163,232.85,161.09,237s0,7.57,5.37,6.59,19.77-20,19.77-20,17.82,21.72,20,26.36,1.47,12.45,1,20.51-1.71,19.77,5.61,29.29,22.71,12.21,35.4,5.61,26.4-29.34,20.29-38.62-19.8-13.86-23.95-22.65-2.71-13.65-2.71-22.68a148.08,148.08,0,0,0-2-20.67s21-5,45.33-8.33c8.47-1.16,3.17-10.74-1.71-12.69-6.12-2.45-33.23.38-40.62-.31-10.67-1-16.11,1.21-18.55,2.92s-5.62,4.15-8.3,3.91-5.62-13.43-5.62-13.43S203.32,178.66,197.22,177.93Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.48,309.45c-8.38,0-16.32-3.28-21-9.41-7-9.13-6.32-20.18-5.81-28.24l.22-3.48c.46-7.22.89-14-1.06-18.17s-16.9-22.52-19.55-25.77c-2.38,3.1-14.64,18.79-19.7,19.71-2.67.48-4.76-.05-5.87-1.5s-1.11-3.54,0-5.8c1.71-3.64,15.1-30.75,20.58-37,4.16-4.73,8.29-4.79,11.6-4.84a15.24,15.24,0,0,0,2.83-.2c1.53-.33,6.48-1.64,6-4.8-.47-2.82-4.8-11.74-4.84-11.83a.5.5,0,0,1,0-.5.51.51,0,0,1,.47-.21c5.82.69,12.73-5,12.8-5a.49.49,0,0,1,.48-.08.48.48,0,0,1,.33.36c1.4,6.31,3.72,12.91,5.17,13,2.27.2,5.08-1.78,7.34-3.37l.63-.45c2.25-1.57,7.69-4,18.88-3,2.77.26,8.54,0,14.64-.25,10.42-.46,22.23-1,26.13.59,3.28,1.31,6.9,6,6.45,9.64-.19,1.56-1.19,3.51-4.86,4-22.08,3-41.64,7.47-44.83,8.21a146.45,146.45,0,0,1,1.93,20.29c0,2-.07,3.73-.14,5.42-.23,6-.39,10.29,2.8,17.05,2.11,4.47,6.77,7.83,11.7,11.39,4.55,3.29,9.25,6.69,12.22,11.2,1.78,2.7,2.06,6.66.81,11.45-2.8,10.73-12.35,23.25-21.29,27.89A32.6,32.6,0,0,1,233.48,309.45Zm-47.25-86.37a.48.48,0,0,1,.39.18c.73.89,17.88,21.83,20.08,26.47,2.06,4.35,1.62,11.3,1.16,18.65l-.22,3.48c-.51,7.91-1.2,18.74,5.6,27.58,7.25,9.43,22.53,11.83,34.77,5.47,8.57-4.45,18.09-16.93,20.78-27.25,1.18-4.51.94-8.19-.67-10.65-2.87-4.36-7.5-7.7-12-10.94-5-3.64-9.79-7.07-12-11.78-3.3-7-3.12-11.63-2.89-17.51.06-1.68.13-3.42.13-5.38a147.7,147.7,0,0,0-2-20.58.5.5,0,0,1,.38-.57c.21-.05,21.3-5.05,45.38-8.35,2.45-.33,3.79-1.39,4-3.14.39-3.16-2.94-7.43-5.83-8.59-3.7-1.48-15.91-.95-25.72-.52-6.4.27-11.93.51-14.77.25-10.88-1-16.08,1.33-18.22,2.83l-.62.44c-2.39,1.69-5.36,3.8-8,3.55s-5.1-9.69-5.88-13c-1.79,1.35-7,5-12.05,4.81,1.09,2.27,4.14,8.83,4.55,11.32.46,2.71-2.06,4.94-6.73,5.94a15.94,15.94,0,0,1-3,.22c-3.12.05-7,.1-10.87,4.5-5.41,6.15-18.72,33.12-20.43,36.75-.9,1.91-.92,3.64-.07,4.76s2.62,1.54,4.9,1.12c4.1-.74,14.52-13.29,19.46-19.83a.51.51,0,0,1,.39-.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.36,179.28l-2,.08a32.67,32.67,0,0,0,4.37,17.8l2.1-.4A31.08,31.08,0,0,1,254.36,179.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.05,240.28c-.22-.65-.41-1.29-.57-1.91-15.13,3.36-27.93,13.16-34.76,19.29,0,.86,0,1.76,0,2.68C214,254.52,227.25,243.74,243.05,240.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.39,246.93c.44.65.83,1.23,1.14,1.74,4.51-4.45,16-14,36.13-19.77,0-.69.05-1.41.08-2.14C221,232.54,209.29,242.11,204.39,246.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.52,213.6c3.59-.39,20.71-3,45.59-19A68.78,68.78,0,0,0,239,201.3a1,1,0,0,0,.83.43l.16,0-.16-1,1-.22a1,1,0,0,0-.15-.34c-.08-.12-7.66-11.31-8.42-20.64-.71.11-1.37.23-2,.37a29.45,29.45,0,0,0,1.09,5.52,91.33,91.33,0,0,1-42.39,17,38.52,38.52,0,0,0-1.75-6.24,12.43,12.43,0,0,0-1.86.82,36.88,36.88,0,0,1,1.51,5.38,17.24,17.24,0,0,0-4.11-3.47,13.45,13.45,0,0,0-1.18,1.2l-.24.28c2.78,1.66,5.47,4.15,6.25,7.78a39.49,39.49,0,0,1-.18,5.88,17.06,17.06,0,0,0-9.68-8.42c-.34.55-.69,1.13-1.05,1.73a14.57,14.57,0,0,1,10,10.37.6.6,0,0,0,.09.22c-.23,1.08-.52,2.17-.86,3.29a21,21,0,0,0-12.41-8.38l-1,1.81a18.61,18.61,0,0,1,12.6,9c-.29.82-.56,1.61-.83,2.39,1.19-1.51,1.92-2.47,1.92-2.47l.74.9.2-.56A40.93,40.93,0,0,0,189.52,213.6ZM232,187.42a55.35,55.35,0,0,0,2.2,5.33c-23.66,15.3-40.52,18.29-44.57,18.81,0-.95,0-1.87,0-2.76a1,1,0,0,0,0-.39l0-.16c-.06-1.35-.18-2.62-.35-3.82A93.6,93.6,0,0,0,232,187.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.22,249.05q-.79-.81-1.5-1.65c-17.4,5-31.14,14.85-39.43,22.09l-.06,1q-.06.9-.12,1.86C215.16,265,229.6,254.1,248.22,249.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.83,219.29c0-.66,0-1.32-.08-2-25.66,1.36-38.32,14.5-43.32,21.59l1.27,1.65C204.15,234,216.25,220.66,241.83,219.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.7,178.76l-2.07.07a32.61,32.61,0,0,0,1.84,16.34l2-.35A31.22,31.22,0,0,1,267.7,178.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.25,179.22a60.11,60.11,0,0,0,6.44,20l2.06-.44a58.08,58.08,0,0,1-6.43-19.41C241.61,179.3,240.92,179.25,240.25,179.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241,208.4c-.09-.69-.17-1.36-.25-2-29.07,3.5-43.65,15.83-49.8,22.94.43.53.86,1.08,1.32,1.64C198,224.27,212.36,211.89,241,208.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.24,305.35c10.5-5.45,21.69-22,21.78-32.76a10.39,10.39,0,0,0-1.52-5.35c-.82-1.27-1.73-2.57-2.69-3.89-3.33-3.52-7.66-6.4-11.62-9.32-22.06,8.31-39.73,25-46.95,31.53a29,29,0,0,0,5.6,14.18C220.17,309.26,235.55,312,248.24,305.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.48,309.45c-8.38,0-16.32-3.28-21-9.41a29.21,29.21,0,0,1-5.71-14.41.49.49,0,0,1,.17-.44l1.35-1.22c8.08-7.32,24.88-22.54,45.76-30.4a.47.47,0,0,1,.47.06c.73.54,1.47,1.07,2.22,1.61a68,68,0,0,1,9.47,7.76c1.1,1.52,2,2.8,2.74,4a10.89,10.89,0,0,1,1.6,5.61c-.09,10.85-11.22,27.61-22,33.23h0A32.6,32.6,0,0,1,233.48,309.45Zm-25.71-23.7a28.13,28.13,0,0,0,5.47,13.69c7.25,9.43,22.53,11.83,34.77,5.47,10.56-5.49,21.42-21.8,21.51-32.32a9.84,9.84,0,0,0-1.44-5.08c-.75-1.15-1.62-2.42-2.67-3.87a66.85,66.85,0,0,0-9.29-7.59l-2-1.45c-20.57,7.82-37.18,22.86-45.18,30.11Zm40.47,19.61h0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.46,157.74a4.21,4.21,0,0,0-1.26.25c-3.31,1.16-4.61,6-2.91,10.85s5.77,7.81,9.07,6.64a4.49,4.49,0,0,0,1.81-1.2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.86,176.24a6.73,6.73,0,0,1-3.93-1.42,13,13,0,0,1-4.55-12.91,6,6,0,0,1,3.65-4.4,5.11,5.11,0,0,1,1.41-.27.5.5,0,0,1,.48.31l6.72,16.54a.51.51,0,0,1-.1.53,5.15,5.15,0,0,1-2,1.34A5.27,5.27,0,0,1,185.86,176.24Zm-3.72-18a4,4,0,0,0-.78.19,5,5,0,0,0-3,3.71A12,12,0,0,0,182.52,174a5.06,5.06,0,0,0,4.68,1,3.86,3.86,0,0,0,1.38-.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.46,157.74a4.21,4.21,0,0,0-1.26.25,4.6,4.6,0,0,0-1.06.54l7,17a1.17,1.17,0,0,0,.2-.06,4.49,4.49,0,0,0,1.81-1.2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.22,176a.55.55,0,0,1-.52-.29l-7-17a.5.5,0,0,1,.18-.6,5.45,5.45,0,0,1,1.17-.61,5.11,5.11,0,0,1,1.41-.27.5.5,0,0,1,.48.31l6.72,16.54a.51.51,0,0,1-.1.53,5.15,5.15,0,0,1-2,1.34l-.17,0Zm-6.45-17.29,6.67,16.18a4,4,0,0,0,1.14-.75l-6.44-15.89a4,4,0,0,0-.78.19A3.47,3.47,0,0,0,180.77,158.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.59,147.69a4.42,4.42,0,0,1,1.14-.6c3.3-1.16,7.36,1.81,9.07,6.64s.41,9.69-2.89,10.86a4.69,4.69,0,0,1-2.17.2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.44,165.33a4.85,4.85,0,0,1-.76-.05.51.51,0,0,1-.42-.35l-5.15-17.09a.51.51,0,0,1,.18-.55,5,5,0,0,1,1.27-.67c3.56-1.25,7.92,1.86,9.71,6.94a12.22,12.22,0,0,1,.45,7.1,6,6,0,0,1-3.65,4.4A4.93,4.93,0,0,1,218.44,165.33Zm-.31-1a4.11,4.11,0,0,0,1.61-.2,5,5,0,0,0,3-3.72,11.23,11.23,0,0,0-.42-6.51c-1.61-4.56-5.4-7.4-8.44-6.33a4,4,0,0,0-.72.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.44,165.33a4.85,4.85,0,0,1-.76-.05.51.51,0,0,1-.42-.35l-5.15-17.09a.51.51,0,0,1,.18-.55,5,5,0,0,1,1.27-.67,4.84,4.84,0,0,1,1.29-.26.5.5,0,0,1,.52.36l5.21,17.64a.49.49,0,0,1-.29.6l-.22.1A4.93,4.93,0,0,1,218.44,165.33Zm-.31-1a3.84,3.84,0,0,0,1.36-.13l-5-16.79a3.53,3.53,0,0,0-1.36.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.21,184.44c-1.73,1.08-3.55,1.94-5.19,1.79-2.69-.25-5.62-13.43-5.62-13.43s-7.08,5.86-13.18,5.13c0,0,4.39,9,4.88,12,.4,2.37-1.77,3.94-4.42,4.84,1.27,3.74,5.41,12.3,16.19,9.67C223.3,202.1,222.57,191.06,221.21,184.44Z",
    style: {
      fill: "#d9d9d9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210,205.4c-8.21,0-11.61-7.11-12.76-10.51a.46.46,0,0,1,0-.38.48.48,0,0,1,.29-.25c1.7-.58,4.49-1.9,4.09-4.29-.47-2.82-4.8-11.74-4.84-11.83a.5.5,0,0,1,0-.5.51.51,0,0,1,.47-.21c5.82.69,12.73-5,12.8-5a.49.49,0,0,1,.48-.08.48.48,0,0,1,.33.36c1.4,6.31,3.72,12.91,5.17,13,1.27.11,2.83-.43,4.89-1.71a.49.49,0,0,1,.75.32c1.36,6.64,2.18,18.13-7.71,20.55A17.15,17.15,0,0,1,210,205.4ZM198.32,195c1.41,3.84,5.5,11.31,15.43,8.88,8.75-2.13,8.31-12.31,7.11-18.67a8.77,8.77,0,0,1-4.89,1.48c-2.65-.24-5.1-9.69-5.88-13-1.79,1.35-7,5-12.05,4.81,1.09,2.27,4.14,8.83,4.55,11.32C203,192,201.45,193.85,198.32,195Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.52,180.38c-.58-1.71-1.09-3.49-1.46-4.9-.31-.81-.6-1.66-.88-2.51-1.18.93-7.46,5.62-13,5,0,0,1.48,3,2.82,6.18,2.36.7,5.68,1.24,8.29-.11A13.89,13.89,0,0,0,212.52,180.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.53,185.33a16.39,16.39,0,0,1-4.63-.74.5.5,0,0,1-.32-.28c-1.32-3.08-2.8-6.14-2.81-6.17a.5.5,0,0,1,0-.5.51.51,0,0,1,.47-.21c5.3.64,11.42-3.93,12.6-4.85a.51.51,0,0,1,.45-.09.5.5,0,0,1,.33.33c.29.9.58,1.74.87,2.48.48,1.83,1,3.51,1.46,4.91a.49.49,0,0,1-.08.48,14.2,14.2,0,0,1-4.35,3.75A8.69,8.69,0,0,1,204.53,185.33Zm-4.12-1.63c2.24.64,5.31,1.09,7.69-.14a13,13,0,0,0,3.86-3.29c-.58-1.72-1.07-3.47-1.38-4.66-.21-.54-.43-1.15-.65-1.82-1.91,1.41-7,4.84-11.89,4.7C198.55,179.56,199.51,181.61,200.41,183.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.06,154.49s3.42,14.65,5.86,18.55,11.23,8.55,15.38,9,7.08-4.64,9.52-8.79,3.17-7.57,2.2-12.94a79.59,79.59,0,0,0-6.6-18.55c-1.58-3-9-6.11-15.86-4.4S181.84,146.68,183.06,154.49Z",
    style: {
      fill: "#d9d9d9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.85,182.61a4.26,4.26,0,0,1-.61,0c-4.49-.53-13.26-5.29-15.74-9.26s-5.79-18.1-5.93-18.71v0c-1.24-7.93,3.63-15.84,10.87-17.65s14.79,1.53,16.43,4.64a80.39,80.39,0,0,1,6.64,18.7c1,5.26.34,8.86-2.26,13.28l-.14.23C211.79,177.73,208.92,182.61,204.85,182.61Zm-21.3-28.21c.14.58,3.46,14.65,5.79,18.38s10.78,8.3,15,8.8c3.74.45,6.6-4.41,8.89-8.32l.14-.23c2.49-4.24,3.05-7.54,2.13-12.59A78.7,78.7,0,0,0,209,142c-1.46-2.77-8.68-5.8-15.3-4.14S182.4,147,183.55,154.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.44,163.29h-.09a.49.49,0,0,1-.4-.57,3,3,0,0,1,1.35-2,4.41,4.41,0,0,1,3.68-.15.5.5,0,0,1-.3,1,3.49,3.49,0,0,0-2.85,0,2.08,2.08,0,0,0-.9,1.28A.49.49,0,0,1,198.44,163.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.93,169.1a9.42,9.42,0,0,1-4.18-1,.5.5,0,1,1,.5-.87c.26.15,6.48,3.55,11-4a.5.5,0,0,1,.69-.16.49.49,0,0,1,.16.68C205.56,168.05,202.41,169.1,199.93,169.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.08,162.86a4.33,4.33,0,0,1-1.91-.41,1,1,0,0,1,1-1.77c.11.06,2.13,1,4.9-2a1,1,0,0,1,1.47,1.37C194.37,162.33,192.43,162.86,191.08,162.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.72,157.82a8.74,8.74,0,0,1-2.71-.43,1,1,0,0,1-.64-1.26,1,1,0,0,1,1.27-.64h0c.17.06,4.23,1.36,5.34-1.59a1,1,0,1,1,1.87.7A5.06,5.06,0,0,1,205.72,157.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.94,157.43a.5.5,0,0,1-.5-.46,6.6,6.6,0,0,1,1.64-4.81,5.67,5.67,0,0,1,4.8-1.26.51.51,0,0,1,.44.56.5.5,0,0,1-.56.44,4.71,4.71,0,0,0-4,1,5.64,5.64,0,0,0-1.34,4,.5.5,0,0,1-.46.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.64,149.62a.48.48,0,0,1-.34-.13.5.5,0,0,1,0-.71s3.26-3.44,7.95-.57a.49.49,0,0,1,.17.68.5.5,0,0,1-.69.17c-4-2.45-6.67.37-6.7.4A.46.46,0,0,1,200.64,149.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.52,161.33s-.74,7.56,0,9.52,7.32,9.27,8.54,11,1.46,1.95-1,6.59-22.7,34.67-23.43,42.24-.25,14.4,7.81,12.93,12.69-21.72,16.11-33.2,7.08-26.36,7.08-29.53-10.26-11.09-11.36-12-1.58-5.07-1.58-7.27S175.49,159.37,174.52,161.33Z",
    style: {
      fill: "#d9d9d9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.44,244.29a5.93,5.93,0,0,1-4.18-1.44c-2.67-2.45-2.56-7.56-2.11-12.24.56-5.75,12-23.88,18.77-34.72,2.29-3.65,4.11-6.53,4.72-7.7,2.27-4.31,2.13-4.5,1.06-6-.43-.6-1.42-1.77-2.55-3.12-2.49-3-5.58-6.64-6.1-8-.75-2-.11-9,0-9.74a.41.41,0,0,1,0-.18c.62-1.24,1.39-1.85,2.11-1.68.38.09,1,.49,1,2.15,0,2.64.62,6.22,1.41,6.89l.62.51c7.45,6,10.91,9.79,10.91,11.89,0,3.34-3.75,18.43-7.1,29.68-.43,1.45-.89,3.05-1.36,4.73-3.29,11.6-7.8,27.48-15.14,28.81A11.5,11.5,0,0,1,164.44,244.29ZM175,161.47c-.2,2.14-.57,7.71,0,9.2.47,1.23,3.76,5.15,5.93,7.74,1.2,1.43,2.15,2.56,2.56,3.13,1.41,2,1.45,2.56-.94,7.12-.64,1.2-2.46,4.1-4.77,7.77-6.76,10.75-18.08,28.76-18.61,34.27-.41,4.18-.57,9.25,1.78,11.42,1.21,1.1,3,1.43,5.44,1,6.73-1.22,11.14-16.76,14.36-28.1.47-1.69.93-3.29,1.36-4.75,3.63-12.18,7.06-26.46,7.06-29.39,0-1.19-1.83-4.08-10.53-11.11l-.65-.52c-1.33-1.13-1.76-5.65-1.76-7.66,0-.89-.21-1.16-.26-1.18S175.49,160.53,175,161.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.57,210.39c.34-1.13.68-2.31,1-3.5l-10.41-4.08c-6.47,10.43-14.09,23.26-14.53,27.85-.73,7.56-.25,14.4,7.81,12.93S179.15,221.87,182.57,210.39Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.44,244.29a5.93,5.93,0,0,1-4.18-1.44c-2.67-2.45-2.56-7.56-2.11-12.24s8.56-18.33,14.61-28.07a.49.49,0,0,1,.6-.2l10.42,4.09a.49.49,0,0,1,.29.6c-.34,1.19-.68,2.37-1,3.51-.43,1.45-.89,3.05-1.36,4.73-3.29,11.6-7.8,27.48-15.14,28.81A11.5,11.5,0,0,1,164.44,244.29Zm8.95-40.87c-6,9.63-13.8,22.73-14.24,27.28-.41,4.18-.57,9.25,1.78,11.42,1.21,1.1,3,1.43,5.44,1,6.73-1.22,11.14-16.76,14.36-28.1.47-1.69.93-3.29,1.36-4.75h0q.45-1.5.9-3.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.51,210.47l-.12.2-.3.5c-.22.37-.44.74-.65,1.11a99,99,0,0,1,13.36,4.28l.55-1.93A100.17,100.17,0,0,0,168.51,210.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172,239.23c.43-.62.85-1.3,1.26-2a39.82,39.82,0,0,1-14.86-2.31q0,1.14.09,2.19A41.36,41.36,0,0,0,172,239.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.2,221.68c-.09.17-.18.34-.26.51s-.19.37-.28.55l-.43.87A49.47,49.47,0,0,1,177.28,228c.22-.63.44-1.27.65-1.91A50.7,50.7,0,0,0,162.2,221.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.89,144.12s6.21,4.38,7.22,6.21,2.26,11.6,2.76,13.64.53,2.38,5.63,3.55,41.09,5.38,47.31,9.75,11.08,9.21,4.72,14.36-24.75-4.53-35.68-9.42-24.61-11.81-27-13.88-1.71-15-1.7-16.44-2.82-4.51-4.49-5.94S217.77,143.59,219.89,144.12Z",
    style: {
      fill: "#d9d9d9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.45,193.58c-7.18,0-17.94-5-26.32-8.86-1.59-.73-3.1-1.43-4.48-2.05-10.72-4.79-24.61-11.78-27.14-14-1.59-1.37-2.2-6.46-1.91-16,0-.38,0-.65,0-.8,0-1-2.32-3.84-4.32-5.56-1.26-1.08-1.14-1.84-.95-2.19.34-.66,1.3-.84,2.65-.5a.35.35,0,0,1,.16.08c.65.45,6.34,4.49,7.37,6.37.72,1.3,1.5,6,2.12,9.86.29,1.74.54,3.25.69,3.9.46,1.87.52,2.1,5.27,3.19,1.28.29,4.65.8,8.92,1.44,12.65,1.89,33.83,5.06,38.56,8.39,3.84,2.7,7.79,6,7.91,9.57.07,1.95-1,3.82-3.17,5.58A8.34,8.34,0,0,1,282.45,193.58Zm-63.64-49.11a.87.87,0,0,0-.57.13c0,.05,0,.39.72,1,1.53,1.31,4.68,4.58,4.67,6.32,0,.16,0,.44,0,.83-.34,11.19.66,14.46,1.56,15.23,2.22,1.91,15.29,8.62,26.89,13.81,1.39.62,2.9,1.32,4.49,2.05,10.71,5,25.36,11.74,30.68,7.43,1.93-1.57,2.85-3.13,2.79-4.76-.11-3.2-4.06-6.38-7.49-8.8-4.53-3.19-25.56-6.33-38.13-8.22-4.29-.64-7.67-1.14-9-1.45-5-1.15-5.43-1.55-6-3.85-.18-.76-.42-2.21-.72-4-.55-3.34-1.38-8.38-2-9.54-.77-1.4-5.23-4.74-7-6A3.55,3.55,0,0,0,218.81,144.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.85,182.21l-3.32-1.5,3.69-10.56c12.13,1.89,26.82,4.47,30.59,7.12,6.22,4.38,11.08,9.21,4.72,14.36S262.78,187.1,251.85,182.21Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.45,193.58c-7.18,0-17.94-5-26.32-8.86-1.59-.73-3.1-1.43-4.48-2.05h0l-3.33-1.51a.49.49,0,0,1-.26-.62L251.74,170a.5.5,0,0,1,.55-.33c11.33,1.77,26.85,4.43,30.81,7.22s7.79,6,7.91,9.57c.07,1.95-1,3.82-3.17,5.58A8.34,8.34,0,0,1,282.45,193.58Zm-30.4-11.82c1.39.62,2.91,1.32,4.5,2.05,10.7,5,25.35,11.74,30.67,7.43,1.93-1.57,2.85-3.13,2.79-4.76-.11-3.2-4.06-6.38-7.49-8.8-3.74-2.63-18.78-5.23-30-7l-3.4,9.73,2.9,1.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.57,189.63c.63.25,1.25.48,1.87.71l6.09-15.5-1.3-.35-.28-.07-.37-.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.8,172.26l-.53-.09-1.38-.25-5.26,13,1.41.65.41.18,5.45-13.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.94,179.65c-1.35,3-3.83,8.58-6.14,13.25a18.25,18.25,0,0,0,2.14.19c2.08-4.26,4.24-9,5.56-12C287,180.58,286.49,180.11,285.94,179.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353,355.06a13.41,13.41,0,0,1,3.66,3s-.9,2.43-6.29,6.61c3.58,3.55,6.78,7.23,8.14,7.06,2.67-.33,10-12.33,12.34-15.66s6.39-5.45,7.05-11.12-2.66-6-4-4.33-9.49,7.13-13.82,8.47-7.75,2.63-7.75,2.63S351,354.06,353,355.06Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.44,372.24c-1.26,0-3.14-1.86-6.27-5.05-.68-.71-1.4-1.44-2.13-2.17a.5.5,0,0,1-.15-.38.52.52,0,0,1,.19-.37c4.19-3.24,5.62-5.42,6-6.13a12.82,12.82,0,0,0-3.3-2.64,2.34,2.34,0,0,1-1.27-1.43,3.65,3.65,0,0,1,.4-2.59.45.45,0,0,1,.25-.22s3.48-1.33,7.78-2.65,12.31-6.72,13.58-8.3a2.64,2.64,0,0,1,3.05-.88c.71.29,2.33,1.44,1.84,5.58s-2.67,6.42-4.78,8.62a22.73,22.73,0,0,0-2.36,2.72c-.45.64-1.07,1.58-1.81,2.7-4.47,6.79-8.67,12.9-10.87,13.18Zm-7.3-7.53c.6.6,1.18,1.2,1.75,1.78,2.22,2.27,4.74,4.84,5.58,4.75,1.93-.24,7.49-8.68,10.17-12.74.74-1.13,1.37-2.08,1.82-2.72a24.78,24.78,0,0,1,2.46-2.85c2-2.08,4.06-4.23,4.51-8,.28-2.41-.18-4.11-1.24-4.55a1.66,1.66,0,0,0-1.88.58c-1.36,1.7-9.53,7.24-14.07,8.63-3.71,1.15-6.77,2.28-7.53,2.56a2.57,2.57,0,0,0-.23,1.66,1.37,1.37,0,0,0,.76.83,13.69,13.69,0,0,1,3.83,3.13.5.5,0,0,1,.08.49C357.11,358.33,356.19,360.71,351.14,364.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.05,340.35c-.86,6.85-3,9.07-11,17.67-6.23,6.7-8.63,10.85-9.55,12.9a3.7,3.7,0,0,0,2,.81c2.67-.33,10-12.33,12.34-15.66s6.39-5.45,7.05-11.12C378.21,342.52,377.76,341.08,377.05,340.35Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.42,372.24a4.47,4.47,0,0,1-2.21-.9.52.52,0,0,1-.18-.63c1.06-2.35,3.59-6.52,9.64-13l.46-.5c7.56-8.14,9.6-10.33,10.42-16.89a.5.5,0,0,1,.34-.41.46.46,0,0,1,.51.12c.66.67,1.36,2.09,1,5-.49,4.14-2.67,6.42-4.78,8.62a22.73,22.73,0,0,0-2.36,2.72c-.45.64-1.07,1.58-1.81,2.7-4.47,6.79-8.67,12.9-10.87,13.18Zm-1.29-1.51a2.55,2.55,0,0,0,1.34.51c1.93-.24,7.49-8.68,10.17-12.74.74-1.13,1.37-2.08,1.82-2.72a24.78,24.78,0,0,1,2.46-2.85c2-2.08,4.06-4.23,4.51-8a8,8,0,0,0-.11-3c-1,5.79-3.49,8.45-10.46,16l-.46.49C360.54,364.67,358.11,368.7,357.13,370.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.62,280.94a.5.5,0,0,1-.3-.9s1.09-.8,2.9-2.09a.5.5,0,0,1,.58.82l-2.89,2.07A.45.45,0,0,1,226.62,280.94Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.87,282.73s33-25.33,58.66-34.66,34.34-3,32.67,6-13.33,38-22.33,54-24.34,42.33-24.34,42.33,14.67,20.33,16,22.67-8.33,2.66-12.33.33a110,110,0,0,1-10-6c-11.66-7.66-12.33-10.66-10.67-13.33,5.33-8.55,11.76-15.7,14.34-26,4.68-18.74,13.35-43,14.33-40.34a81.75,81.75,0,0,1-29.33,18c-17.67,6-29.19,4.45-37-6",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.85,375.48c-2.81,0-6.06-.57-7.9-1.65-.93-.54-1.58-.89-2.22-1.23a87.69,87.69,0,0,1-7.8-4.78c-11.61-7.63-12.76-10.91-10.82-14,1.36-2.19,2.81-4.31,4.21-6.36,4.2-6.12,8.16-11.91,10.06-19.5,2.92-11.67,8.48-29.2,12-37A83.4,83.4,0,0,1,250,306.21c-18.16,6.16-29.75,4.26-37.59-6.17a.51.51,0,0,1,.1-.7.5.5,0,0,1,.7.1c7.54,10,18.78,11.83,36.47,5.82a82.62,82.62,0,0,0,27.87-16.67c.57-1,1-1.54,1.38-1.56a.74.74,0,0,1,.71.53.5.5,0,0,1-.11.52s-.5.51-1.39,1.32c-2.6,5.05-8.78,22.66-12.82,38.79-1.94,7.77-6,13.63-10.2,19.83-1.4,2-2.84,4.15-4.19,6.32s-1.53,4.72,10.52,12.64a85.83,85.83,0,0,0,7.73,4.74c.64.34,1.3.7,2.24,1.25,3.33,1.94,10.4,1.89,11.61.69.11-.11.14-.18,0-.35-1.31-2.28-15.82-22.41-16-22.62a.48.48,0,0,1,0-.54c.16-.27,15.44-26.52,24.33-42.33,9.1-16.18,20.64-45,22.28-53.84.59-3.18-.19-5.77-2.24-7.51-2.7-2.29-10.16-5.06-29.76,2.07-25.3,9.2-58.21,34.34-58.54,34.59a.5.5,0,1,1-.61-.79c.33-.26,33.36-25.49,58.8-34.74,14.89-5.41,25.8-6.08,30.76-1.89,2.34,2,3.23,4.9,2.57,8.45-1.65,8.94-13.25,37.9-22.39,54.15-8.4,14.94-22.49,39.18-24.17,42.06,1.8,2.49,14.57,20.24,15.84,22.45a1.22,1.22,0,0,1-.2,1.55C283,375.13,281.06,375.48,278.85,375.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.85,275.8a.5.5,0,0,1-.41-.22.49.49,0,0,1,.13-.69c6.71-4.67,16.14-11,23-14.54a.5.5,0,1,1,.46.88c-6.79,3.54-16.19,9.82-22.87,14.48A.52.52,0,0,1,233.85,275.8Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.29,296.94a.49.49,0,0,1-.38-.18.51.51,0,0,1,.06-.71l8.57-7.21c.54-1.92,6.24-21.17,18.86-31.18a.5.5,0,0,1,.71.08.5.5,0,0,1-.08.7c-13,10.29-18.52,30.61-18.57,30.81a.54.54,0,0,1-.16.26l-8.68,7.31A.52.52,0,0,1,267.29,296.94Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.11,290.08a.39.39,0,0,1-.18,0,.49.49,0,0,1-.28-.64l1.83-4.57a.49.49,0,0,1,.65-.28.51.51,0,0,1,.28.65l-1.83,4.57A.51.51,0,0,1,301.11,290.08Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.55,281.49a.63.63,0,0,1-.19,0,.51.51,0,0,1-.28-.65l6.62-16.55a.5.5,0,0,1,.65-.28.5.5,0,0,1,.28.65L305,281.18A.5.5,0,0,1,304.55,281.49Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.2,373.4c4,2.33,13.67,2,12.33-.33s-16-22.67-16-22.67,4.06-7,9.23-15.92c-6.44-.83-10.06-3.56-12-5.92-2.66,10-9,17.1-14.2,25.51-1.66,2.67-1,5.67,10.67,13.33A110,110,0,0,0,271.2,373.4Z",
    style: {
      fill: "#d9d9d9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.85,375.48c-2.81,0-6.06-.57-7.9-1.65h0c-.93-.54-1.58-.89-2.22-1.23a87.69,87.69,0,0,1-7.8-4.78c-11.61-7.63-12.76-10.91-10.82-14,1.36-2.18,2.8-4.29,4.2-6.34,4.11-6,8-11.67,9.94-19a.49.49,0,0,1,.37-.36.53.53,0,0,1,.49.17c1.81,2.17,5.32,4.92,11.71,5.74a.54.54,0,0,1,.39.28.49.49,0,0,1,0,.47c-4.56,7.9-8.25,14.26-9.06,15.64,1.8,2.49,14.57,20.24,15.84,22.45a1.22,1.22,0,0,1-.2,1.55C283,375.13,281.06,375.48,278.85,375.48ZM265,329.58c-2.06,7.1-5.84,12.62-9.84,18.46-1.39,2-2.83,4.14-4.17,6.3s-1.53,4.72,10.52,12.64a85.83,85.83,0,0,0,7.73,4.74c.64.34,1.3.7,2.24,1.25h0c3.33,1.94,10.4,1.89,11.61.69.11-.11.14-.18,0-.35-1.31-2.28-15.82-22.41-16-22.62a.48.48,0,0,1,0-.54s3.87-6.64,8.86-15.28C270.34,334,267,331.65,265,329.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.53,350.4s-1.33-1-3,1.67a33.69,33.69,0,0,0-2.66,5.33l-7.74-8.78c-1.22,1.78-2.43,3.58-3.6,5.45-1.66,2.67-1,5.67,10.67,13.33a110,110,0,0,0,10,6c4,2.33,13.67,2,12.33-.33S267.53,350.4,267.53,350.4Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.85,375.48c-2.81,0-6.06-.57-7.9-1.65-.93-.54-1.58-.89-2.22-1.23a87.69,87.69,0,0,1-7.8-4.78c-11.61-7.63-12.76-10.91-10.82-14,1.21-1.94,2.5-3.84,3.61-5.47a.5.5,0,0,1,.38-.22.49.49,0,0,1,.41.17l7.2,8.17a35,35,0,0,1,2.4-4.66,4,4,0,0,1,2.41-2.05,1.72,1.72,0,0,1,1.31.25.38.38,0,0,1,.11.11c.6.83,14.7,20.38,16,22.71a1.22,1.22,0,0,1-.2,1.55C283,375.13,281.06,375.48,278.85,375.48Zm-24.67-26.05c-1,1.5-2.15,3.19-3.22,4.91-1.29,2.05-1.53,4.72,10.52,12.64a85.83,85.83,0,0,0,7.73,4.74c.64.34,1.3.7,2.24,1.25,3.33,1.94,10.4,1.89,11.61.69.11-.11.14-.18,0-.35-1.26-2.2-14.86-21.08-15.91-22.53a.86.86,0,0,0-.52,0c-.38.08-1,.42-1.71,1.59a34,34,0,0,0-2.63,5.25.49.49,0,0,1-.37.31.52.52,0,0,1-.47-.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.2,367.4a110,110,0,0,0,10,6c3.6,2.1,11.78,2,12.42.31-15.18-.81-27.76-12.89-33.33-19.21C249,357.07,250.17,360.15,261.2,367.4Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.76,375.5a17,17,0,0,1-7.81-1.67c-.93-.54-1.58-.89-2.22-1.23a87.69,87.69,0,0,1-7.8-4.78h0c-11.23-7.38-12.57-10.65-11.09-13.54a.5.5,0,0,1,.82-.11c6,6.78,18.21,18.26,33,19a.47.47,0,0,1,.39.22.51.51,0,0,1,.06.45,2.12,2.12,0,0,1-1.37,1.09A12.43,12.43,0,0,1,278.76,375.5Zm-28.31-20.06c-.52,1.87.67,4.73,11,11.54h0a85.83,85.83,0,0,0,7.73,4.74c.64.34,1.3.7,2.24,1.25,2.66,1.55,8.16,1.92,10.72,1.13C268.1,372.72,256.5,362.16,250.45,355.44Z",
    style: {
      fill: "#263238"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMusicBro);
export default __webpack_public_path__ + "static/media/Music-bro.cacd3cb89c52da43e5f40d0ffcb3d051.svg";
export { ForwardRef as ReactComponent };